import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import _values from "lodash/values";
import _some from "lodash/some";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { Heading, Tooltip } from '@nerdwallet/currency';
import { FORMATS, VALUE_SIZES } from './constants';
import QuickFactValue from './quick-fact-value';
import styles from './quick-facts.module.less';

var QuickFacts = function QuickFacts(_ref) {
  var analytics = _ref.analytics,
      className = _ref.className,
      enableAnalytics = _ref.enableAnalytics,
      quickFacts = _ref.quickFacts;
  useDeprecatedPropsWarning({
    component: 'QuickFacts',
    deprecatedProps: [{
      version: '5.5.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var quickFactComponents = [];
  var filteredQuickFacts = quickFacts.filter(function (quickFact) {
    return quickFact && !_isNil(quickFact.value);
  });

  if (_isEmpty(filteredQuickFacts)) {
    return null;
  } // Need to use a forEach here because styling will not work if each
  // quickFact is wrapped in an enclosing div. All items must be
  // direct siblings.


  filteredQuickFacts.forEach(function (quickFact) {
    quickFactComponents.push( /*#__PURE__*/React.createElement("div", {
      key: "".concat(quickFact.id, "-label"),
      className: classNames([styles.cell, styles.label])
    }, /*#__PURE__*/React.createElement(Heading, {
      size: 1,
      level: 5,
      uppercase: true,
      className: quickFact.label && classes('padding-bottom-2')
    }, quickFact.labelTooltip ? /*#__PURE__*/React.createElement(Tooltip, {
      id: quickFact.id,
      label: quickFact.label,
      content: quickFact.labelTooltip,
      title: "More information about ".concat(quickFact.label),
      analytics: (enableAnalytics || analytics) && _objectSpread({
        entityNamePrefix: "quick_facts_component_tooltip"
      }, analytics)
    }) : quickFact.label)));
    quickFactComponents.push( /*#__PURE__*/React.createElement("div", {
      key: "".concat(quickFact.id, "-value"),
      className: classNames([styles.cell, styles.value])
    }, /*#__PURE__*/React.createElement(QuickFactValue, {
      analytics: analytics,
      quickFact: quickFact
    })));
  });

  var hasWideDriver = _some(filteredQuickFacts, 'wide');

  return /*#__PURE__*/React.createElement("div", {
    className: classNames([className, styles.quickFactsTable, styles["table".concat(filteredQuickFacts.length, "Cols")]], _defineProperty({}, styles.hasWideDriver, hasWideDriver))
  }, quickFactComponents);
};

QuickFacts.propTypes = {
  /** Class name(s) to apply to the component */
  className: PropTypes.string,

  /**
   * Flag to enable bedrock analytics
   */
  enableAnalytics: PropTypes.oneOfType([PropTypes.bool]),

  /** Analytics Prop */
  analytics: PropTypes.shape({
    entityName: PropTypes.string
  }),

  /** List of quick facts to display */
  quickFacts: PropTypes.arrayOf(PropTypes.shape({
    /** The unique id for this particular quick fact */
    id: PropTypes.string.isRequired,

    /** The quick fact label text */
    label: PropTypes.node,

    /** The quick fact value */
    value: PropTypes.node,

    /** Specifies how the value should be formatted.
    Supports 'currency', 'currencyWithCents', 'percent', 'string', and 'unformatted'.
    Defaults to 'string'. */
    valueFormat: PropTypes.oneOf(_values(FORMATS)),

    /** The popover text to be associated with the value */
    valueTooltip: PropTypes.node,

    /** The type size of the value. Supports 'large' and 'small'.
     Defaults to 'large'. */
    valueSize: PropTypes.oneOf(_values(VALUE_SIZES)),

    /** The quick fact description */
    description: PropTypes.node,

    /** Whether to display the driver in wider width, e.g. the LOA driver */
    wide: PropTypes["boolean"]
  })).isRequired
};
QuickFacts.defaultProps = {
  analytics: {},
  className: ''
};
export default QuickFacts;